export enum UserAction {
  SET_USER = "setUser",
  GET_USER = "getUser",
  CHANGE_WALLET = "changeActiveWallet",
  UPDATE_VERIFICATION = "updateVerification",
  UPDATE_BALANCE = "updateBalance",
}
